$(document).ready(function(){
    $("a#update_address").click(function(e){
        e.preventDefault()
        $(".form.hidden-by-css").toggle();
    });
});
